// Encapsulates everything needed for ACH Entries from a UI perspective.
import { Button, CircularProgress, Grid, TextField } from '@mui/material';
import React, { useState } from 'react';
import { handleChange, trimField} from '../Shared/Functions';

export function TokenUpdate({
    updateToken,
    isCCToken,
    onSubmit,
    onCancel }) {
    const [working, setWorking] = useState<boolean>(false)
    let [model, setModel] = useState<any>(
        {
            firstName: updateToken?.firstName,
            lastName: updateToken?.lastName,
            streetAddress: updateToken?.streetAddress,
            city: updateToken?.city,
            state: updateToken?.state,
            zip: updateToken?.zip,
            expirationMonth: updateToken?.expirationMonth,
            expirationYear: updateToken?.expirationYear
        });


    let submit = () => {
        setWorking(true)
        onSubmit(model)
    }

    return (<div>
        <form>
            <TextField
                onChange={e => handleChange(e, model, setModel)}
                onBlur={e => trimField(e, model, setModel)}
                margin="normal"
                id="firstName"
                name="firstName"
                label="First Name"
                type="text"
                value={model?.firstName}
                fullWidth
                autoComplete="given-name"
            />
            <TextField
                onChange={e => handleChange(e, model, setModel)}
                onBlur={e => trimField(e, model, setModel)}
                margin="normal"
                id="lastName"
                name="lastName"
                label="Last Name"
                type="text"
                value={model?.lastName}
                fullWidth
                autoComplete="family-name"
            />
            <TextField
                onChange={e => handleChange(e, model, setModel)}
                onBlur={e => trimField(e, model, setModel)}
                margin="normal"
                id="streetAddress"
                name="streetAddress"
                label="Address"
                type="text"
                value={model?.streetAddress}
                fullWidth
                autoComplete="street-address"
            />
            <TextField
                onChange={e => handleChange(e, model, setModel)}
                onBlur={e => trimField(e, model, setModel)}
                margin="normal"
                id="city"
                name="city"
                label="City"
                type="text"
                value={model?.city}
                fullWidth
                autoComplete="address-level2"
            />
            <TextField
                onChange={e => handleChange(e, model, setModel)}
                onBlur={e => trimField(e, model, setModel)}
                margin="normal"
                id="state"
                name="state"
                label="State"
                type="text"
                value={model?.state}
                fullWidth
                autoComplete="address-level1"
            />
            <TextField
                onChange={e => handleChange(e, model, setModel)}
                onBlur={e => trimField(e, model, setModel)}
                margin="normal"
                id="zip"
                name="zip"
                label="Zip"
                type="text"
                value={model?.zip}
                fullWidth
                autoComplete="postal-code"
            />
            {isCCToken ?
                <div style={{ display: "flex" }}>
                    <TextField
                        onChange={e => handleChange(e, model, setModel)}
                        onBlur={e => trimField(e, model, setModel)}
                        margin="normal"
                        id="expirationMonth"
                        name="expirationMonth"
                        label="Epiration Month"
                        type="number"
                        value={model?.expirationMonth}
                        fullWidth
                        style={{ marginRight: "10px" }}
                        autoComplete="cc-exp-month"
                    />
                    <TextField
                        onChange={e => handleChange(e, model, setModel)}
                        onBlur={e => trimField(e, model, setModel)}
                        margin="normal"
                        id="expirationYear"
                        name="expirationYear"
                        label="Expiration Year"
                        type="number"
                        value={model?.expirationYear}
                        autoComplete="cc-exp-year"
                        fullWidth
                    />
                </div>
            : <></>}
        </form>

        <Grid className="method-update-buttons-group">
            {onCancel &&
                <Button variant="outlined"
                    id="cancel"
                    color="primary"
                    type="button"
                    onClick={onCancel}
                    style={{ marginRight: "10px" }}>
                    Cancel
                </Button>
            }
            <Button variant="contained"
                className="login-button"
                disabled={model?.zip === "" ||
                    (isCCToken && 
                    (model?.expirationMonth === "" || model?.expirationYear === ""))}
                id="submit"
                color="primary"
                type="button"
                onClick={submit}>
                {working ?
                    ' Please Wait...'
                    : 'Submit'
                }
            </Button>
        </Grid>
        {working &&
            <>
                <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
            </>
        }
    </div>)
}
